import React, { useCallback, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import { LoaderIcon } from '../Components/Global/Icons';
import { FadeAlert } from '../Components/Global/Transitions';
import { getTestsSummary } from '../Services/PtaasApiService';
import Tests from '../Models/Tests';
import ProjectsList from '../Components/Tables/ProjectsList';
import RecentActivity from '../Components/Global/RecentActivity';
import { hasReportLink } from '../Utilities/AccessControl';

const ProjectsPage: React.FC = () => {
 const { instance, accounts } = useMsal();
  const [loading, setLoading] = useState(false);
  const [tests, setTests] = useState<Tests[]>([]);
  const [fetchError, setFetchError] = useState(false);
  const [projectIds, setProjectIds] = useState<{ [testId: string]: number | null }>({});
  const [projectStatuses, setProjectStatuses] = useState<{ [testId: string]: string | null }>({});
  const [projectIdsLoading, setProjectIdsLoading] = useState(false);

  const fetchProjects = useCallback(async (): Promise<void> => {
    setLoading(true);
    setProjectIdsLoading(true);
    try {
      // Single enriched call: the canopy id + raw project status now come back on the list,
      // so no per-test getProjectByTestId fan-out (the old 1 + N).
      const returnedTests = await getTestsSummary(instance, accounts[0]);
      setTests(returnedTests);

      const ids: { [testId: string]: number | null } = {};
      const statuses: { [testId: string]: string | null } = {};

      returnedTests.forEach((test) => {
        statuses[test.id] = test.projectStatus ?? null;
        if (hasReportLink(test.status)) {
          ids[test.id] = test.canopyProjectId ?? null;
        }
      });
      setProjectIds(ids);
      setProjectStatuses(statuses);
    } catch (error) {
      console.error('Failed to fetch data:', error);
      setFetchError(true);
    } finally {
      setLoading(false);
      setProjectIdsLoading(false);
    }
  }, [instance, accounts]);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);





  return loading ? (
    <LoaderIcon />
  ) : (
    <Row>
      <Col sm={12} as='h1'>Dashboard</Col>

      <Col xl={9}>
        <FadeAlert show={fetchError} dismissFunction={() => setFetchError(false)} />
        <ProjectsList
          tests={tests}
          projectIds={projectIds}
          projectStatuses={projectStatuses}
          loading={projectIdsLoading}
          OnProjectChange={fetchProjects}
        />
      </Col>
      <Col xl={3}>
        <RecentActivity />
      </Col>
    </Row>
  );
};

export default ProjectsPage;
